import { WMButtonVariant } from '@walkme/wm-ui';
import React, { useRef } from 'react';
import { create } from 'react-modal-promise';
import { AudienceGraphql } from '../../../../../generated/apollo-hooks';
import StyledWMDialog from '../../../Dialogs/StyledWMDialog/StyledWMDialog';
import { useActivateAudiencesMutation } from '../../hooks/hooks';
import classes from './AudienceValidationErrorDialog.module.scss';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.audiences.createAudienceDialog.audienceValidationErrorDialog';

export const AudienceValidationErrorDialog = ({ isOpen, close, audienceName, closeParent, archivedAudience }: $TSFixMe) => {
    const { t } = useTranslation('', { keyPrefix });
    const onDiscard = () => {
        close();
        closeParent();
    };

    const activateAudiencesMutation = useActivateAudiencesMutation();
    const isRestoring = useRef(false)

    const onRestore = () => {
      if (isRestoring.current) return;
        isRestoring.current = true;
        close();
        closeParent();
        activateAudiencesMutation([archivedAudience as AudienceGraphql]);
    };
    const existsInArchived = archivedAudience != null;

    const buttons = [
        {
            children: !existsInArchived ? t('discard') : t('restore'),
            variant: WMButtonVariant.Secondary,
            className: classes.discardButton,
            onClick: () => (!existsInArchived ? onDiscard() : onRestore()),
            'data-testid': !existsInArchived ? 'audience-with-same-rules-exists-discard' : 'audience-with-same-rules-exists-restore'
        },
        {
            children: t('backToEditing'),
            variant: WMButtonVariant.Primary,
            onClick: close,
            'data-testid': 'audience-with-same-rules-exists-back'
        }
    ];

    if (existsInArchived) {
        buttons.unshift({
            children: t('discard'),
            variant: WMButtonVariant.Text,
            className: classes.discardButtonLeft,
            onClick: () => onDiscard(),
            'data-testid': 'audience-with-same-rules-exists-discard'
        });
    }

    const title = !existsInArchived ? t('anotherAudienceTitle') : t('archievedAudienceTitle');

    return (
        <StyledWMDialog title={title} open={isOpen} onClose={close} buttons={buttons} data-testid={'audience-with-same-rules-exists-dialog'}>
            <>
                {!existsInArchived ? t('anotherAudienceFragment1') : t('archievedAudienceFragment1')}
                {' '}
                <span data-testid="audience-with-same-rules-exists-dialog-audience" className={classes.audienceName}>
                    {audienceName}
                </span>
                {' '}
                {!existsInArchived ? t('anotherAudienceFragment2') : t('archievedAudienceFragment2')}
            </>
        </StyledWMDialog>
    );
};

AudienceValidationErrorDialog.openModal = create(AudienceValidationErrorDialog as $TSFixMe);
export default AudienceValidationErrorDialog;
